import { useState } from 'react';
import type { AIMetric } from '../../api/dataApi';
import { Button } from '../ui/Button';
import { TextField } from '../ui/TextField';

// The metrics found in a document, each with a checkbox (all on by default):
// filter, All / None (on the filtered rows), and the list itself. `off` holds
// the unticked ones by list path - shared by the AI review and the editor.
export function MetricChecklist({ metrics, off, onChange }: { metrics: AIMetric[]; off: Record<string, boolean>; onChange: (next: Record<string, boolean>) => void }) {
  const [filter, setFilter] = useState('');
  const f = filter.trim().toLowerCase();
  const visible = metrics.filter((m) => `${m.name} ${m.unit ?? ''}`.toLowerCase().includes(f));
  const setMany = (value: boolean) => {
    const next = { ...off };
    for (const m of visible) {
      if (value) next[m.path] = true;
      else delete next[m.path];
    }
    onChange(next);
  };
  return (
    <>
      <div className="flex items-center gap-2">
        <TextField aria-label="Filter metrics" value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter metrics" />
        <Button variant="secondary" onClick={() => setMany(false)}>All</Button>
        <Button variant="secondary" onClick={() => setMany(true)}>None</Button>
      </div>
      <div className="max-h-64 overflow-y-auto flex flex-col gap-0.5">
        {visible.map((m) => (
          <label key={m.path} className="inline-flex items-center gap-2 text-[13px] cursor-pointer">
            <input type="checkbox" checked={!off[m.path]} onChange={(e) => onChange({ ...off, [m.path]: !e.target.checked })} />
            <span className="break-all">{m.name}</span>
            {m.unit && <span className="text-black/45 dark:text-white/45">{m.unit}</span>}
          </label>
        ))}
        {visible.length === 0 && <span className="text-xs text-black/50 dark:text-white/50">No metric matches.</span>}
      </div>
    </>
  );
}
